import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Arrow } from '../../assets/images/arrow_suggestion.svg';
import { reveal } from './keyframe-animations';
import { ParkLogo } from './ParkLogo';
import { Photo } from './Photo';

export const ImageGameSettings: React.FC = () => {
  const { t, i18n } = useTranslation('translation');
  return (
    <div
      className={css`
        position: relative;
        width: 256px;
        height: 160px;
        margin: auto;

        .photo {
          width: 100%;
          height: 100%;
          transform: rotate(-2deg);
        }
        .cover {
          display: flex;
          justify-content: center;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
        .logo {
          width: 192px;
          padding: 8px 0 0;
          svg,
          img {
            height: 88px;
          }
        }
        .settings {
          display: flex;
          align-items: center;
          background-color: #f5f1e3;
          border-radius: 16px;
          box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.24);
          padding: 0 10px 0 6px;
          height: 32px;
          color: #897a66;
          position: absolute;
          left: -8px;
          bottom: -12px;

          &::before {
            content: '\ue0f0';
            font-size: 24px;
            margin-right: 4px;
          }
        }
        .arrow {
          position: absolute;
          bottom: 16px;
          left: 2px;
          transform: scaleY(-1);
          @media (prefers-reduced-motion: no-preference) {
            svg {
              transform: translateY(-4px);
              animation: ${reveal} 0.4s ease-in-out infinite alternate;
            }
          }
        }
        /* less than iPhone6/7/8 display size */
        @media screen and (max-width: 374px) {
          width: 238px;
          height: 149px;
        }
      `}
    >
      <div className="photo">
        <Photo
          srcSet={`
        /images/lp/img_lp_photo_04-2x.jpg 2x,
        /images/lp/img_lp_photo_04.jpg 1x`}
        />
        <div className="cover">
          <div className="logo">
            <ParkLogo width={192} height={88} lang={i18n.language} />
          </div>
        </div>
      </div>
      <div className="settings" aria-hidden={true}>
        {t('game_settings')}
      </div>
      <div className="arrow">
        <Arrow />
      </div>
    </div>
  );
};
